// extracted by mini-css-extract-plugin
export default {"modal":"Mba-z","modalContent":"Nba-z","footer":"Oba-z","cancelBtn":"Pba-z","disabled":"Qba-z","formWrapper":"Rba-z","fade":"Sba-z","fade-in":"Tba-z","iframe":"Uba-z"};